import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  CreateCryptoAddressRequestDto,
  CreateCryptoAddressResponseDto,
} from '../model';

const createCryptoAddress = async (
  networkName: string,
  args: CreateCryptoAddressRequestDto,
  options?: RequestHandlerOptions
): Promise<CreateCryptoAddressResponseDto> => {
  const request = () =>
    apiClient.post(`/operations/crypto/${networkName}/template`, args);

  const response = await handleRequest<CreateCryptoAddressResponseDto>(
    request,
    options
  );

  return response.data;
};

export { createCryptoAddress };
